import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';
import {logger} from '@/utils/logger';

import BusinessCountrySettings from './BusinessCountrySettings';
import Summary from './Summary';
import useBusinessCountryUpdate from './useBusinessCountryUpdate';

const Details = () => {
  const params = useParams();
  const countryCode = params?.countryCode || '';
  const {isLoading, item, handleUpdate, fetchItem} = useBusinessCountryUpdate();

  useEffect(() => {
    if (countryCode) {
      // `fetchItem` try/catches into showErrorMessage, so this only fires if
      // that reporting itself threw. Attached because an unhandled rejection
      // would leave the onboarding tab editing an empty country; dev logger
      // rather than a second toast, since a toast is what just failed.
      fetchItem(countryCode).catch(logger.error);
    }
  }, [countryCode, fetchItem]);

  const tabs: TabItem[] = [
    {
      id: 'general',
      title: 'General',
      content: <Summary item={item} />,
    },
    {
      id: 'onboarding',
      title: 'Onboarding',
      content: (
        <BusinessCountrySettings handleSave={handleUpdate} item={item} />
      ),
    },
  ];

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={item?.name || ''} />
      <Tabs key={isLoading?.toString()} tabs={tabs} queryKey={'tab'} />
    </main>
  );
};

export default Details;
